// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import { setClickAnalyticsData, trackClick, trackPageView } from '@tcp/core/src/analytics/actions';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import useDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import {
  getAPIConfigForAdobe,
  getSessionDataForAdobe,
  getUserState,
} from '@tcp/core/src/adobeAnalytics/adobe.selectors';
import BuyItAgainReducer from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgain.reducer';
import BuyItAgainSaga from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgain.saga';
import {
  getBIABagpageConfigData,
  getIsBIACombinedCarouselKillSwitch,
  getIsRecommendationCarouselRedesignEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import { openQuickViewWithValues } from '../../../../common/organisms/QuickViewModal/container/QuickViewModal.actions';
import {
  buyItAgainProducts,
  getTotalProductsCount,
  getInitialProductLoaded,
  getPageProducts,
  getBIAPageProductsIsLoading,
  getBiaInitialApiActualProductCount,
} from '../../../account/BuyItAgain/container/BuyItAgain.selectors';
import { getUserLoggedInState } from '../../../account/User/container/User.selectors';

import { getCartOrderList } from '../../CartItemTile/container/CartItemTile.selectors';
import {
  fetchBiaBagPageDrawerProducts,
  getBuyItAgainBagPageProducts,
  getMoreBiaBagPageDrawerProducts,
  openShopAllDrawer,
} from './BuyItAgainBagPage.actions';
import { getBIADynamicData, getIsShopAllDrawerOpen } from './BuyItAgainBagPage.selectors';
import BuyItAgainBagPageWrapper from '../molecules/BuyItAgainBagPageWrapper/views';
import BuyItAgainBagPageSaga from './BuyItAgainBagPage.saga';
import BuyItAgainBagPageReducer from './BuyItAgainBagPage.reducer';

const mapStateToProps = (state) => {
  const { size = false } = getCartOrderList(state) || {};

  return {
    biaProducts: buyItAgainProducts(state),
    biaDrawerProducts: getPageProducts(state),
    isShopAllDrawerOpen: getIsShopAllDrawerOpen(state),
    isBIACombinedCarouselEnabled: getIsBIACombinedCarouselKillSwitch(state),
    biaDynamicData: getBIADynamicData(state),
    totalProductsCount: getTotalProductsCount(state),
    initialProductLoaded: getInitialProductLoaded(state),
    isLoggedIn: getUserLoggedInState(state),
    orderItemsCount: size,
    isLoadingBIAPageProducts: getBIAPageProductsIsLoading(state),
    biaInitialApiActualProductCount: getBiaInitialApiActualProductCount(state),
    getBIAConfigData: getBIABagpageConfigData(state),
    pageData: {
      pageName: 'buy it again',
      pageSection: 'account dashboard',
      pageSubSection: '',
      pageType: 'profile page',
    },
    User: getUserState(state),
    APIConfig: getAPIConfigForAdobe(state),
    session: getSessionDataForAdobe(state),
    isRecommendationCarouselRedesignEnabled: getIsRecommendationCarouselRedesignEnabled(state),
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    onQuickViewOpenClick: (payload) => dispatch(openQuickViewWithValues(payload)),
    openShopAllDrawer: (payload) => dispatch(openShopAllDrawer(payload)),
    getBIABagPageProducts: () => dispatch(getBuyItAgainBagPageProducts()),
    getBIADrawerproducts: () => dispatch(fetchBiaBagPageDrawerProducts()),
    getMoreBiaDrawerProducts: () => dispatch(getMoreBiaBagPageDrawerProducts()),
    trackAnalyticsPageViewWeb: (eventData) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackPageView(eventData));
        clearTimeout(timer);
      }, 800);
    },
    trackAnalyticsClickWeb: (eventData) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackClick(eventData));
        clearTimeout(timer);
      }, 800);
    },
  };
};
const withReducer = withDynamicReducer([
  {
    key: 'buyItAgain',
    reducer: BuyItAgainReducer,
  },
  {
    key: 'buyItAgainBagPage',
    reducer: BuyItAgainBagPageReducer,
  },
]);
const withSaga = useDynamicSaga([
  { key: 'BuyItAgainSaga', saga: BuyItAgainSaga },
  {
    key: 'BuyItAgainBagPageSaga',
    saga: BuyItAgainBagPageSaga,
  },
]);
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withReducer, withSaga, withConnect)(BuyItAgainBagPageWrapper);
